import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateDrivingLicenseSearch: Validator = (data: SearchContextType) => {
  const {
    drivingLicenseNumber,
    firstName,
    middleNames,
    lastName,
    dateOfBirth,
  } = data;

  const hasLicense = !!drivingLicenseNumber?.trim();
  const hasAnyOtherPart =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isLicenseOnlySearch = hasLicense && !hasAnyOtherPart;

  if (!hasLicense) {
    return { isValid: false, errors: [] };
  }

  return isLicenseOnlySearch
    ? { isValid: true, errors: [] }
    : {
        isValid: false,
        errors: [ValidationErrorMessages.invalidDrivingLicense],
      };
};

export default validateDrivingLicenseSearch;
